import RecoverPassword from './RecoverPassword'
import useRecoverPasswordPath from './useRecoverPasswordPath'

export { useRecoverPasswordPath }
export default RecoverPassword
